












import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({
    type: Boolean
  })
  value: boolean

  @Emit('input')
  onClose() {
    return false
  }
}
